export const GET_LEAVES_WIDGETS = "GET_LEAVES_WIDGETS";
export const RESET_LEAVES_WIDGETS = "RESET_LEAVES_WIDGETS";
export const GETWORKTIMEWIDGETS = "GETWORKTIMEWIDGETS";
export const RESET_SCHELDER_WIDGETS = "RESET_SCHELDER_WIDGETS";
